var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 74,
    stroke: "url(#paint0_linear_9_312)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.505 71.5791L70.145 63.7219C69.3193 63.2701 68.3434 63.287 67.534 63.7665C66.7242 64.2465 66.2412 65.0946 66.2412 66.0358V81.6153C66.2412 82.5521 66.7213 83.3986 67.5256 83.8792C67.9456 84.1301 68.4113 84.256 68.878 84.256C69.3054 84.256 69.7339 84.1504 70.1281 83.9382L84.4887 76.2163C85.3411 75.7576 85.8732 74.8714 85.8772 73.9029C85.8807 72.9344 85.355 72.0442 84.505 71.5791ZM70.0503 79.6555V68.0115L80.7827 73.8841L70.0503 79.6555Z",
    fill: "url(#paint1_linear_9_312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.522 61.4908L106.519 61.461C106.464 60.9378 105.916 56.2842 103.653 53.9172C101.038 51.1332 98.0739 50.795 96.6481 50.6328C96.5301 50.6194 96.422 50.607 96.3253 50.5941L96.2117 50.5822C87.6186 49.9574 74.6412 49.8721 74.5113 49.8716L74.4999 49.8711L74.4885 49.8716C74.3585 49.8721 61.3811 49.9574 52.7106 50.5822L52.5961 50.5941C52.5038 50.6065 52.4022 50.6179 52.2916 50.6308C50.8822 50.7935 47.9494 51.1322 45.3271 54.0169C43.1723 56.3586 42.5495 60.9125 42.4855 61.4243L42.4781 61.4908C42.4587 61.7085 42 66.8912 42 72.0943V76.9582C42 82.1613 42.4587 87.3441 42.4781 87.5623L42.4815 87.595C42.5366 88.1098 43.0841 92.6781 45.336 95.0461C47.7947 97.7369 50.9035 98.0929 52.5757 98.2844C52.8401 98.3146 53.0677 98.3404 53.2229 98.3677L53.3732 98.3885C58.3347 98.8606 73.8909 99.0932 74.5505 99.1026L74.5703 99.1031L74.5901 99.1026C74.7201 99.1021 87.697 99.0168 96.2901 98.392L96.4037 98.3801C96.5123 98.3657 96.6343 98.3528 96.7682 98.3389C98.1696 98.1901 101.087 97.8812 103.673 95.0357C105.827 92.6935 106.451 88.1395 106.514 87.6282L106.522 87.5618C106.541 87.3436 107 82.1613 107 76.9582V72.0943C107 66.8912 106.541 61.709 106.522 61.4908ZM103.191 76.9582C103.191 81.774 102.77 86.7336 102.73 87.1889C102.569 88.443 101.912 91.3243 100.862 92.4654C99.2432 94.2462 97.5805 94.4227 96.3665 94.5512C96.2197 94.5665 96.0838 94.5814 95.9608 94.5968C87.6494 95.1978 75.1619 95.2901 74.5867 95.2935C73.9415 95.2841 58.6129 95.0495 53.8026 94.6027C53.5562 94.5626 53.2899 94.5318 53.0092 94.5001C51.5854 94.3369 49.6365 94.1138 48.1379 92.4654L48.1027 92.4277C47.0712 91.353 46.4329 88.6587 46.2708 87.2037C46.2405 86.8596 45.8091 81.8415 45.8091 76.9582V72.0943C45.8091 67.284 46.2286 62.3299 46.2693 61.8652C46.4622 60.3879 47.1317 57.6812 48.1379 56.5872C49.8061 54.7523 51.5651 54.549 52.7285 54.4146C52.8396 54.4017 52.9432 54.3898 53.0389 54.3774C61.4714 53.7734 74.0486 53.6837 74.4999 53.6802C74.9511 53.6832 87.5239 53.7734 95.8815 54.3774C95.9841 54.3903 96.0962 54.4032 96.2167 54.4171C97.4133 54.5535 99.2219 54.7598 100.882 56.5302L100.897 56.5465C101.929 57.6212 102.567 60.3626 102.729 61.8468C102.758 62.1717 103.191 67.2007 103.191 72.0943V76.9582Z",
    fill: "url(#paint2_linear_9_312)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_312",
    x1: 75,
    y1: 0.00000109061,
    x2: 110.481,
    y2: 191.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_312",
    x1: 76.0592,
    y1: 63.3946,
    x2: 81.2796,
    y2: 89.9722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_312",
    x1: 74.5001,
    y1: 49.8711,
    x2: 83.4466,
    y2: 113.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(42 42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeLogo);
export default __webpack_public_path__ + "static/media/YouTubeLogo.2e9d1df5ec6c1e851826b8b2a65d5094.svg";
export { ForwardRef as ReactComponent };